import { ReactElement } from 'react';
import { format } from 'date-fns';

import { useGetMainTokenUSDRatioQuery } from 'modules/api/actions/getMainTokenUSDRatio';
import { Table } from 'modules/common/components/Table';
import { DEFAULT_LONG_DECIMAL_PLACES } from 'modules/common/const';
import mainTokenIcon from 'modules/common/icons/main-token-icon.svg';
import { AmountCell } from 'modules/delegateStaking/components/AmountCell';
import { PoolCell } from 'modules/delegateStaking/components/PoolCell';
import { useGlobalTranslation } from 'modules/i18n/hooks/useGlobalTranslation';
import { IPoolUnstake } from 'modules/pool/types';

import { translation } from '../ClaimTable/translation';
import { useStyles } from './useStyles';

interface IClaimRowProps {
  className?: string;
  isHidePoolName?: boolean;
  poolUnstake: IPoolUnstake;
}

export function ClaimRow({
  className,
  poolUnstake,
  isHidePoolName,
}: IClaimRowProps): ReactElement | null {
  const { classes, cx } = useStyles();
  const { t, keys } = useGlobalTranslation(translation);

  const { amount, executedAt } = poolUnstake;

  const { data: usdRatio } = useGetMainTokenUSDRatioQuery();

  return (
    <Table.Row className={cx(classes.row, className)}>
      {!isHidePoolName && (
        <PoolCell
          address={poolUnstake.poolAddress}
          className={classes.poolCell}
          icon={mainTokenIcon}
          poolName={t(keys.tokens.main)}
        />
      )}

      <AmountCell
        amount={t(keys.unit.tokenValue, {
          value: amount.decimalPlaces(DEFAULT_LONG_DECIMAL_PLACES).toFormat(),
          token: t(keys.tokens.main),
        })}
        className={classes.commonMdCell}
        mdLabel={t(keys.withdrawalAmount)}
        subAmount={
          usdRatio && !usdRatio.isZero() && amount
            ? t(keys.unit.$, {
                value: amount
                  .decimalPlaces(DEFAULT_LONG_DECIMAL_PLACES)
                  .toFormat(),
                token: t(keys.tokens.main),
              })
            : undefined
        }
      />

      <AmountCell
        amount={format(executedAt, 'MMM dd, yyyy')}
        className={classes.commonMdCell}
        mdLabel={t(keys.initiated)}
        subAmount={format(executedAt, 'hh:mm a')}
      />
    </Table.Row>
  );
}
